import { useQuery } from 'react-query';

import { getCriticalPathRemovedTableData as queryFn } from 'api/endPoints/getTopCriticalPathRemoved';

export const useQueryCriticalPathRemovedTableData = (params) => {
    return useQuery(['criticalPathRemovedTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
